import { Component, input, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject, takeUntil, tap } from 'rxjs';
import { camps } from '../../../../../models/models.generated';

@Component({
    selector: 'app-camp-category-edit',
    templateUrl: './camp-category-edit.component.html',
    styleUrls: ['./camp-category-edit.component.scss'],
    standalone: false,
})
export class CampCategoryEditComponent implements OnInit, OnDestroy {
    destroySubj: Subject<void> = new Subject<void>();
    form = input.required<UntypedFormGroup>();
    parentCategories = input.required<camps.CategoryModel[]>();
    subcategories = input.required<camps.CategoryModel[]>();

    currentSubcategories: WritableSignal<camps.CategoryModel[]> = signal([]);

    ngOnInit(): void {
        const form = this.form();

        // valueChanges does not emit for the initial form value, so seed the
        // subcategory list from the already-selected parent. Without this, an
        // imported/assigned subcategory is never shown in edit mode (ticket 17332).
        this.setCurrentSubcategories(form.controls['parentId'].value);

        form.controls['parentId'].valueChanges
            .pipe(
                takeUntil(this.destroySubj),
                tap((x: string) => this.setCurrentSubcategories(x))
            )
            .subscribe();
    }

    private setCurrentSubcategories(parentId: string): void {
        const filteredSubcategories = this.subcategories().filter((category) => category.parentId === parentId);
        this.currentSubcategories.set(filteredSubcategories);
    }

    ngOnDestroy(): void {
        this.destroySubj.next();
        this.destroySubj.complete();
    }

    public selectSubcategory(category: camps.CategoryModel) {
        const form = this.form();

        if (!category) {
            form.controls.id.setValue(null);
            form.controls.name.setValue(null);
            return;
        }

        form.controls.id.setValue(category.id);
        form.controls.name.setValue(category.name);
    }

    public selectParent(category: camps.CategoryModel) {
        const form = this.form();

        form.controls.parentId.setValue(category.id);
        form.controls.parentName.setValue(category.name);
        this.selectSubcategory(null);
    }

    public isSelectedParent(category: camps.CategoryModel): boolean {
        const form = this.form();

        if (!form || !form.value) {
            return false;
        }

        return form.value.parentId == category.id;
    }

    public isSelected(category: camps.CategoryModel): boolean {
        const form = this.form();

        if (!form || !form.value) {
            return false;
        }

        return form.value.id == category.id;
    }
}
